<div class="payment-container">
    <div  class="modal" tabindex="-1" role="dialog" id="modPushPay" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-body"><span class="{{textColor}} text-center font-weight-bold">{{message}}</span></div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
            </div>
        </div>
        </div>
      </div>
        <form [formGroup]="formPay" class="form" (submit)="sendPayment()">
            <div class="row justify-content-center">
                <div class="form-group col-sm-6 ml-4 mb-3">
                    <p class="d-block text-center fs-2">Envoyer un lien de paiement au client</p>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="form-group form-floating col-sm-3  mb-2">
                    <input type="tel" placeholder="Num&#233;ro t&#233;l&#233;phone" id="phone" class="form-control"
                        formControlName="phone">
                     <label class="form-label ml-2 d-flex align-items-start" for="phone">Num&#233;ro t&#233;l&#233;phone</label>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="form-group form-floating col-sm-3  mb-2">
                    <input type="number" placeholder="Entrer le montant" id="amount" class="form-control"
                        formControlName="amount">
                 <label class="form-label ml-2 d-flex align-items-start" for="amount">Montant</label>
                </div>
            </div>
        
        <div class="d-grid gap-2 col-2 mx-auto">
            <button type="submit" class="btn btn-success"   [disabled]="!this.formPay.valid">Valider</button>
        </div>
    </form>
</div>